import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from 'app/core/i18n/translate.pipe';

export interface InvalidItemRow {
  code: string;
  name: string;
  reasons: string[];
}

export interface InvalidItemsDialogData {
  items: InvalidItemRow[];
}

@Component({
  selector: 'app-invalid-items-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, TranslatePipe],
  templateUrl: './invalid-items-modal.component.html',
})
export class InvalidItemsModalComponent {
  constructor(
    private dialogRef: MatDialogRef<InvalidItemsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InvalidItemsDialogData
  ) {}

  // el usuario los revisa manualmente en la tabla
  review(): void {
    this.dialogRef.close();
  }

  // se quitan del documento los artículos inválidos
  remove(): void {
    this.dialogRef.close('remove');
  }
}
